module.exports = __webpack_public_path__ + "static/media/ks_large_rings.30b59f9b.svg";